<template>
	<van-popup v-model="show" position="top" class="gmxzpopup">
		<div>
			<van-sticky>
				<div class="header-gmxz">
					<h4>购买须知</h4>
					<van-icon name="cross" size="22px" @click="show = false" />
				</div>
			</van-sticky>
			<div>
				<!-- <h4 style="text-align: center;line-height: 44px;background-color: aliceblue;">购买须知</h4> -->
				<div class="flex" v-if="dataList.length>0">
					<!-- <div class="img"> -->
					<van-image :src="dataList" @click="onShowImg">
						<template v-slot:error>加载失败</template>
					</van-image>
					<!-- <img :src="dataList" alt="" @click="onShowImg"> -->
					<!-- </div> -->
				</div>
				<div class="flex no-data" v-else>
					暂无购买须知
				</div>
			</div>
		</div>
	</van-popup> 
</template>

<script>
	import CubePage from '../TP/cube-page.vue'
	import CubeView from '@/components/TP/cube-view'
	import * as util from '@/utils/network'
	import {
		Toast
	} from "vant";
	export default {
		components: {
			CubePage,
			CubeView
		},
		data() {
			return {
				tjitem: this.$route.query,
				dataList: [],
				show: false,
				showimg: false,
				index: 0,
				images: []
			};
		},
		// created() {
		// 	this.getData()
		// },
		methods: {
			refOnShow(item) {
				this.tjitem = item
				this.getData()
				this.show = true
			},
			onShowImg() {
				this.show = true
			},
			getData() {
				var url = "/addons/litestore/api.goods/get_sku_notice"
				let that = this;
				that.images = []
				that.index = 0
				util.get(url, that.tjitem,
					function(result) {
						that.dataList = result.data
						console.log(that.dataList)
						that.images.push(that.dataList)
					});
			}
		}
	}
</script>

<style lang="less" scoped>
	::v-deep.gmxzpopup {
		max-height: 100%;
	}

	::v-deep.cube-page {
		.header {
			background: linear-gradient(to right, rgba(14, 122, 248) 20%, rgba(55, 151, 254));
			color: #fff;

			.cubeic-back {
				color: #fff;
			}
		}
	}

	.header-gmxz {
		padding: 0 10px;
		display: flex;
		justify-content: space-between;
		height: 44px;
		align-items: center;
		background: linear-gradient(to right, #ffaa7f, #ffaa00);
		color: #fff;
	}

	.flex {
		display: flex;
		align-items: center;
		flex-direction: column;
	}

	.img {

		// width: 200px;
		// height: 200px;
		img {
			width: 100%;
			height: 100%;
		}
	}

	.no-data {
		line-height: 150px;
	}
</style>
